import basicOptions from '@/router/basic-options';
import { userPermission } from '@/constants';
import StoreAdjustment from '@/views/StoreAdjustment/index.vue';
import StoreAdjustmentDetail from '@/views/StoreAdjustment/Detail/index.vue';
import { pageAuthorization } from '@/router-middleware';
import { routeName } from '@/constants/routeName';
export default [
    {
        path: 'store-adjustment',
        name: routeName.STORE_ADJUSTMENT,
        component: StoreAdjustment,
        meta: {
            ...basicOptions,
            breadcrumbsItems: basicOptions.breadcrumbsItems.storeAdjustment.list,
            middleware: [
                pageAuthorization([
                    userPermission.P_GET_STORE_ADJUSTMENT,
                ]),
                ...basicOptions.middleware,
            ],
        },
    },
    {
        path: 'store-adjustment/:storeId/detail',
        name: routeName.STORE_ADJUSTMENT_DETAIL,
        component: StoreAdjustmentDetail,
        // TODO 상점정산 상세페이지의 경우 breadcrumbsItems을 만들기위해 meta를 함수로 만들어 동적인 값 전달하도록 하기
        meta: (route) => ({
            ...basicOptions,
            breadcrumbsItems: basicOptions.breadcrumbsItems.storeAdjustment.detail.concat({
                text: `${route.query.storeName} 발행할 세금계산서 초안`,
                href: `/vuex-store/${route.query.storeId}/adjustment`,
                disabled: true,
            }),
            middleware: [
                pageAuthorization([
                    userPermission.P_GET_STORE_ADJUSTMENT,
                ]),
                ...basicOptions.middleware,
            ],
        }),
    },
];
